import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import {
    IRCACorporateDashboardEntity,
    IRCACorporateArgsFilters,
    IAvgActionPlansPerMill,
    IRcaMethodologyUsedByMill,
    IRCAComplianceByMillCorporate,
    IActionPlanComplianceByMillCorporate,
} from "./RCACorporateDashboardEntityInterfaces";
import {
    getAvgActionPlansPerMill,
    getRcaMethodologyUsedByMill,
    getRCAComplianceByMillCorporate,
    getActionPlanComplianceByMillCorporate,
} from "api/queries/RCA/RCACorporateDashboardAPI";
import { buildRCACorporateArgs, RCACorporateArgsDateKey } from "./helpers";

export const RCACorporateDashboardEntity: IRCACorporateDashboardEntity = {
    GetRCAComplianceByMill: (filters: IRCACorporateArgsFilters) => {
        const { loading, error, data } = useQuery(getRCAComplianceByMillCorporate, {
            fetchPolicy: "no-cache",
            variables: {
                args: buildRCACorporateArgs(filters, RCACorporateArgsDateKey.INPUT_DATE),
            },
        });

        const [rcaComplianceByMill, setRcaComplianceByMill] = useState<IRCAComplianceByMillCorporate[]>([]);

        useEffect(() => {
            if (data?.rca_compliance_by_mill && Array.isArray(data.rca_compliance_by_mill)) {
                setRcaComplianceByMill(data.rca_compliance_by_mill);
            }
        }, [data]);

        return { loading, rcaComplianceByMill, apolloQueryError: error };
    },
    GetActionPlanComplianceByMill: (filters: IRCACorporateArgsFilters) => {
        const { loading, error, data } = useQuery(getActionPlanComplianceByMillCorporate, {
            fetchPolicy: "no-cache",
            variables: {
                args: buildRCACorporateArgs(filters, RCACorporateArgsDateKey.INPUT_DATE),
            },
        });

        const [actionPlanComplianceByMill, setActionPlanComplianceByMill] = useState<
            IActionPlanComplianceByMillCorporate[]
        >([]);

        useEffect(() => {
            if (data?.action_plan_compliance_by_mill && Array.isArray(data.action_plan_compliance_by_mill)) {
                setActionPlanComplianceByMill(data.action_plan_compliance_by_mill);
            }
        }, [data]);

        return { loading, actionPlanComplianceByMill, apolloQueryError: error };
    },
    GetAvgActionPlansPerMill: (filters: IRCACorporateArgsFilters) => {
        const { loading, error, data } = useQuery(getAvgActionPlansPerMill, {
            fetchPolicy: "no-cache",
            variables: {
                args: buildRCACorporateArgs(filters, RCACorporateArgsDateKey.MAX_DATE),
            },
        });

        const [avgActionPlansPerMill, setAvgActionPlansPerMill] = useState<IAvgActionPlansPerMill[]>([]);

        useEffect(() => {
            if (data?.avg_action_plans_per_mill && Array.isArray(data.avg_action_plans_per_mill)) {
                setAvgActionPlansPerMill(data.avg_action_plans_per_mill);
            }
        }, [data]);

        return { loading, avgActionPlansPerMill, apolloQueryError: error };
    },
    GetRcaMethodologyUsedByMill: (filters: IRCACorporateArgsFilters) => {
        const { loading, error, data } = useQuery(getRcaMethodologyUsedByMill, {
            fetchPolicy: "no-cache",
            variables: {
                args: buildRCACorporateArgs(filters, RCACorporateArgsDateKey.MAX_DATE),
            },
        });

        const [rcaMethodologyUsedByMill, setRcaMethodologyUsedByMill] = useState<IRcaMethodologyUsedByMill[]>([]);

        useEffect(() => {
            if (data?.rca_methodology_used_by_mill && Array.isArray(data.rca_methodology_used_by_mill)) {
                setRcaMethodologyUsedByMill(data.rca_methodology_used_by_mill);
            }
        }, [data]);

        return { loading, rcaMethodologyUsedByMill, apolloQueryError: error };
    },
};
